import mapValues from "lodash/fp/mapValues";

import { svg } from "./svgStyles";

export const inputBase = {
  background: "background",
  border: "1px solid",
  borderColor: "grey5",
  boxSizing: "border-box",
  borderRadius: "2px",
  color: "text",
  fontFamily: "body",
  fontWeight: "light",
  transition: "none",
  ...svg("text"),

  "&:hover, &:focus": {
    backgroundImage: "none",
    borderColor: "primary",
    color: "primary",
    outline: "none",
    ...svg("primary"),
  },

  "&[disabled], &:disabled": {
    background: "grey9",
    borderColor: "grey7",
    color: "grey7",
    cursor: "not-allowed",
    ...svg("grey7"),
  },
};

export const baseSelect = {
  ...inputBase,
  cursor: "pointer",
};

export const inputMaterial = {
  borderTop: "none",
  borderLeft: "none",
  borderRight: "none",
};

export const inputMedium = {
  height: "40px",
  fontSize: "20px",
  letterSpacing: "0.025em",
  padding: "0 20px",
};

export const inputLarge = {
  height: "60px",
  fontSize: "30px",
  letterSpacing: "0.025em",
  padding: "0 30px",
};

export const inputRound = {
  borderRadius: "10000px",
};

export const inputRoundWithButton = {
  borderTopLeftRadius: "10000px",
  borderBottomLeftRadius: "10000px",
};

export const selectHover = {
  "&:focus + svg, &:hover + svg": {
    "path, circle, rect": {
      fill: "primary",

      "&[stroke]": {
        fill: "none",
        stroke: "primary",

        "&[fill]": {
          fill: "primary",
        },
      },
    },
  },
};

export const inputInvalid = {
  borderColor: "danger",
  color: "danger",

  "&:hover, &:focus": {
    borderColor: "danger",
    color: "danger",
    outline: "none",
  },
};

const preInputVariants = {
  inputRegularMedium: {
    ...inputBase,
    ...inputMedium,
  },
  inputRegularLarge: {
    ...inputBase,
    ...inputLarge,
  },
  inputRoundMedium: {
    ...inputBase,
    ...inputMedium,
    ...inputRound,
  },
  inputRoundLarge: {
    ...inputBase,
    ...inputLarge,
    ...inputRound,
  },
  inputMaterialMedium: {
    ...inputBase,
    ...inputMaterial,
    ...inputMedium,
  },
  inputMaterialLarge: {
    ...inputBase,
    ...inputMaterial,
    ...inputLarge,
  },
  inputRegularMediumWithButton: {
    ...inputBase,
    ...inputMedium,
  },
  inputRoundMediumWithButton: {
    ...inputBase,
    ...inputMedium,
    ...inputRoundWithButton,
  },
  inputRegularLargeWithButton: {
    ...inputBase,
    ...inputLarge,
  },
  inputRoundLargeWithButton: {
    ...inputBase,
    ...inputLarge,
    ...inputRoundWithButton,
  },
  inputMaterialMediumWithButton: {
    ...inputBase,
    ...inputMaterial,
    ...inputMedium,
  },
  inputMaterialLargeWithButton: {
    ...inputBase,
    ...inputMaterial,
    ...inputLarge,
  },
  inputRegularMediumIsInvalid: {
    ...inputBase,
    ...inputMedium,
    ...inputInvalid,
  },
  inputRegularLargeIsInvalid: {
    ...inputBase,
    ...inputLarge,
    ...inputInvalid,
  },
  inputRoundMediumIsInvalid: {
    ...inputBase,
    ...inputMedium,
    ...inputRound,
    ...inputInvalid,
  },
  inputRoundLargeIsInvalid: {
    ...inputBase,
    ...inputLarge,
    ...inputRound,
    ...inputInvalid,
  },
  inputMaterialMediumIsInvalid: {
    ...inputBase,
    ...inputMaterial,
    ...inputMedium,
    ...inputInvalid,
  },
  inputMaterialLargeIsInvalid: {
    ...inputBase,
    ...inputMaterial,
    ...inputLarge,
    ...inputInvalid,
  },
  inputRegularMediumWithButtonIsInvalid: {
    ...inputBase,
    ...inputMedium,
    ...inputInvalid,
  },
  inputRoundMediumWithButtonIsInvalid: {
    ...inputBase,
    ...inputMedium,
    ...inputRoundWithButton,
    ...inputInvalid,
  },
  inputRegularLargeWithButtonIsInvalid: {
    ...inputBase,
    ...inputLarge,
    ...inputInvalid,
  },
  inputRoundLargeWithButtonIsInvalid: {
    ...inputBase,
    ...inputLarge,
    ...inputRoundWithButton,
    ...inputInvalid,
  },
  inputMaterialMediumWithButtonIsInvalid: {
    ...inputBase,
    ...inputMaterial,
    ...inputMedium,
    ...inputInvalid,
  },
  inputMaterialLargeWithButtonIsInvalid: {
    ...inputBase,
    ...inputMaterial,
    ...inputLarge,
    ...inputInvalid,
  },
};

export const inputVariants = mapValues((value) => ({
  "input&": value,
}))(preInputVariants);

const preSelectVariants = {
  selectRegularMedium: {
    ...baseSelect,
    ...inputMedium,
    ...selectHover,
  },
  selectRegularLarge: {
    ...baseSelect,
    ...inputLarge,
    ...selectHover,
  },
  selectMaterialMedium: {
    ...baseSelect,
    ...inputMaterial,
    ...inputMedium,
    ...selectHover,
  },
  selectMaterialLarge: {
    ...baseSelect,
    ...inputMaterial,
    ...inputLarge,
    ...selectHover,
  },
  selectRoundMedium: {
    ...baseSelect,
    ...inputRound,
    ...inputMedium,
    ...selectHover,
  },
  selectRoundLarge: {
    ...baseSelect,
    ...inputRound,
    ...inputLarge,
    ...selectHover,
  },
};

export const selectVariants = mapValues((value) => ({
  "select&": value,
}))(preSelectVariants);
